import { useState } from "react";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { changePassword } from "@/lib/api";

const inputCls =
  "w-full bg-transparent border-b border-[#FDFBF7]/20 focus:border-[#D4AF37] outline-none py-2.5 font-body text-[#FDFBF7] placeholder:text-[#A89F91]/50 transition-colors duration-300";
const labelCls = "block font-body text-[11px] tracking-[0.2em] uppercase text-[#A89F91] mb-1";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setCur(""); setNext(""); setConfirm(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error("New password must be at least 8 characters.");
    if (next !== confirm) return toast.error("New passwords do not match.");
    setSaving(true);
    try {
      await changePassword(cur, next);
      toast.success("Password updated successfully");
      reset();
      onOpenChange(false);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not update password.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) reset(); onOpenChange(v); }}>
      <DialogContent data-testid="change-password-dialog" className="border-[#D4AF37]/25 bg-[#140A0D] max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#FDFBF7] flex items-center gap-2"><KeyRound size={20} className="text-[#D4AF37]" /> Change Password</DialogTitle>
          <DialogDescription className="font-body text-sm text-[#A89F91]">Enter your current password and choose a new one (min 8 characters).</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-6">
          <div><label className={labelCls}>Current Password</label><input data-testid="cp-current" type="password" className={inputCls} value={cur} onChange={(e) => setCur(e.target.value)} /></div>
          <div><label className={labelCls}>New Password</label><input data-testid="cp-new" type="password" className={inputCls} value={next} onChange={(e) => setNext(e.target.value)} /></div>
          <div><label className={labelCls}>Confirm New Password</label><input data-testid="cp-confirm" type="password" className={inputCls} value={confirm} onChange={(e) => setConfirm(e.target.value)} /></div>
          <button data-testid="cp-submit" type="submit" disabled={saving} className="w-full flex items-center justify-center gap-2 px-8 py-3.5 bg-[#D4AF37] text-[#0A0607] font-body text-sm tracking-[0.2em] uppercase disabled:opacity-60">
            {saving && <Loader2 size={16} className="animate-spin" />} Update Password
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
